export const HOST_URL = process.env.HOST_URL ?? ''
export const OLD_WIGGOT_URL = process.env.OLD_WIGGOT_URL ?? ''
export const STAGE = process.env.STAGE ?? ''

export const PATHS = {
  AUTH: '/auth',
  AUTH_LOGIN: '/auth/login',
  AUTH_LOGIN_CALLBACK: (urlCallback?: string) =>
    `/auth/login${
      urlCallback ? `?urlCallback=${encodeURIComponent(urlCallback)}` : ''
    }`,
  ACCOUNT: '/account',
  PROFILE: '/profile',
  MESSAGES: '/messages',
  DEVELOPMENTS: '/developments',
  DEVELOPMENT_ACCOUNT: '/developmentAccount',
  SEARCH: '/search',
  DEVELOPMENT_SEARCHER: '/developmentsSearcher',
  LISTS: '/lists',
  LOGIN: OLD_WIGGOT_URL,
  MY_PROPERTIES: '/my-properties',
  CONTACTS: '/crm',
  AGENTS: '/crm',
  LEADS: '/crm',
  PDF_EDIT: '/customDataSheet',
  PDF_EDIT_V2: (propertyId: string) => `/edit-and-share/${propertyId}`,
  UPDATE_PROPERTY: '/updateProperty',
  PREVIEW_PROPERTY: '/dataSheetPreview',
  REQUIREMENTS: '/requirements',
  DASHBOARD: '/dashboard',
  AGENCY_SITE: '/minisites/configuracion',
  LEAD_MANAGEMENT: '/lead-management',
  LOGIN_ROL: '/loginrol',
  STORE: '/shop',
  APPRAISALS: '/appraisals',
  APPRAISALS_TRIAL_START: '/appraisals/trial/step/property-type',
  APPRAISALS_TRIAL: '/trial',
  APPRAISALS_OVERVIEW: '/overview',
  NEW_PORTAL: '/minisites',
  NEW_PROPERTY_V2: (params?: string) =>
    `/my-properties/create${params?.length ? `?${params}` : ''}`,
  EDIT_PROPERTY_V2: (propertyId: string, params?: string) =>
    `/my-properties/update/${propertyId}${params?.length ? `?${params}` : ''}`,
  PROPERTY_DETAIL_V2: (propertyId: string, params?: string) =>
    `/my-properties/detail/${propertyId}${params?.length ? `?${params}` : ''}`,
  NEW_PROPERTY: (params: string) => `/my-properties/property-form?${params}`,
  EDIT_PROPERTY: (propertyId: string) =>
    `/my-properties/property-form/${propertyId}`,
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  MANAGE_PLATFORMS: '/manage-platforms',
  REPORT_ADVANCE: (propertyId: string) =>
    `/my-properties/report?propertyId=${propertyId}`,
  SHOP: '/shop',
  NEW_AGENCY: '/home/create-agency',
  HOME: '/home',
  privacity: '/privacy-notice',
  BOOST_PROPERTY_DETAIL: (requirementId: string, propertyId: string) =>
    `/boost/property/${requirementId}/${propertyId}`,
  ASSOCIATION_AGENCIES: '/association/agencies',
  ASSOCIATION_PROPERTIES: '/association/properties',
  ASSOCIATION_BROKERS: '/association/brokers',
  ASSOCIATION_REPORTS: '/association/reports',
  ACCOUNT_PROFILE: '/account/profile',
  ACCOUNT_AGENCY: '/account/agency',
  ACCOUNT_MEMBERS: '/account/members',
  PROPERTY_PERFORMANCE: '/property-performance',
  COMPA_LENDING: '/lending',
  MINISITES_ONBOARDING: '/minisites/onboarding',
  MINISITES_EDITOR: '/minisites/editor',
  SUSCRIPTION_EXPIRED: '/suscription-expired',
  PUBLIC_PROPERTY: ({
    slug,
    propertyId,
    ref
  }: {
    slug: string
    propertyId: string
    ref?: string
  }) => `/property/${slug}/${propertyId}${ref ? `?reference=${ref}` : ''}`
}

export const ROUTES = {
  AUTH: `${HOST_URL}${PATHS.AUTH}`,
  AUTH_REGISTER: `${HOST_URL}${PATHS.AUTH}/sign-up`,
  AUTH_LOGIN: `${HOST_URL}${PATHS.AUTH}/login`,
  AUTH_LOGIN_CALLBACK: (urlCallback?: string) =>
    `${HOST_URL}${PATHS.AUTH_LOGIN_CALLBACK(urlCallback)}`,
  ACCOUNT: `${OLD_WIGGOT_URL}${PATHS.ACCOUNT}`,
  PROFILE: `${OLD_WIGGOT_URL}${PATHS.PROFILE}`,
  MESSAGES: `${OLD_WIGGOT_URL}${PATHS.MESSAGES}`,
  SEARCH: `${HOST_URL}${PATHS.SEARCH}`,
  DEVELOPMENTS: `${OLD_WIGGOT_URL}${PATHS.DEVELOPMENTS}`,
  DEVELOPMENT_SEARCHER: `${OLD_WIGGOT_URL}${PATHS.DEVELOPMENT_SEARCHER}`,
  LISTS: `${HOST_URL}${PATHS.LISTS}`,
  LOGIN: `${OLD_WIGGOT_URL}`,
  LOGIN_ROL: `${OLD_WIGGOT_URL}${PATHS.LOGIN_ROL}`,
  MY_PROPERTIES: `${HOST_URL}${PATHS.MY_PROPERTIES}`,
  CONTACTS: `${OLD_WIGGOT_URL}${PATHS.CONTACTS}`,
  AGENTS: `${OLD_WIGGOT_URL}${PATHS.AGENTS}`,
  LEADS: `${OLD_WIGGOT_URL}${PATHS.LEADS}`,
  PDF_EDIT: `${OLD_WIGGOT_URL}${PATHS.PDF_EDIT}`,
  PDF_EDIT_V2: (propertyId: string) =>
    `${HOST_URL}${PATHS.PDF_EDIT_V2(propertyId)}`,
  UPDATE_PROPERTY: `${OLD_WIGGOT_URL}${PATHS.UPDATE_PROPERTY}`,
  PREVIEW_PROPERTY: `${OLD_WIGGOT_URL}${PATHS.PREVIEW_PROPERTY}`,
  REQUIREMENTS: `${OLD_WIGGOT_URL}${PATHS.REQUIREMENTS}`,
  DASHBOARD: `${OLD_WIGGOT_URL}${PATHS.DASHBOARD}`,
  AGENCY_SITE: `${HOST_URL}${PATHS.AGENCY_SITE}`,
  MINISITES_ONBOARDING: `${HOST_URL}${PATHS.MINISITES_ONBOARDING}`,
  MINISITES_EDITOR: `${HOST_URL}${PATHS.MINISITES_EDITOR}`,
  LEAD_MANAGEMENT: `${HOST_URL}${PATHS.LEAD_MANAGEMENT}`,
  STORE: `${HOST_URL}${PATHS.STORE}`,
  APPRAISALS: (cta = false) => {
    const baseUrl = `${HOST_URL}${PATHS.APPRAISALS}`
    return cta ? `${baseUrl}?cta=true` : baseUrl
  },
  APPRAISALS_TRIAL: `${HOST_URL}${PATHS.APPRAISALS_TRIAL_START}`,
  APPRAISALS_TRIAL_ROOT: `${HOST_URL}${PATHS.APPRAISALS_TRIAL}`,
  APPRAISALS_OVERVIEW: `${HOST_URL}${PATHS.APPRAISALS_OVERVIEW}`,
  NEW_PORTAL: `${HOST_URL}${PATHS.NEW_PORTAL}`,
  NEW_PROPERTY: (params: string) => `${HOST_URL}${PATHS.NEW_PROPERTY(params)}`,
  EDIT_PROPERTY: (propertyId: string) =>
    `${HOST_URL}${PATHS.EDIT_PROPERTY(propertyId)}`,
  NEW_PROPERTY_V2: (params?: string) =>
    `${HOST_URL}${PATHS.NEW_PROPERTY_V2(params)}`,
  EDIT_PROPERTY_V2: (propertyId: string, params?: string) =>
    `${HOST_URL}${PATHS.EDIT_PROPERTY_V2(propertyId, params)}`,
  PROPERTY_DETAIL_V2: (propertyId: string, params?: string) =>
    `${HOST_URL}${PATHS.PROPERTY_DETAIL_V2(propertyId, params)}`,
  TERMS_AND_CONDITIONS: `${HOST_URL}${PATHS.TERMS_AND_CONDITIONS}`,
  MANAGE_PLATFORMS: `${HOST_URL}${PATHS.MANAGE_PLATFORMS}`,
  REPORT_ADVANCE: (propertyId: string) =>
    `${HOST_URL}${PATHS.REPORT_ADVANCE(propertyId)}`,
  DEVELOPMENT_ACCOUNT: `${OLD_WIGGOT_URL}${PATHS.DEVELOPMENT_ACCOUNT}`,
  SHOP: `${HOST_URL}${PATHS.SHOP}`,
  NEW_AGENCY: `${HOST_URL}${PATHS.NEW_AGENCY}`,
  HOME: `${HOST_URL}${PATHS.HOME}`,
  PRIVACITY: `${HOST_URL}${PATHS.privacity}`,
  NEW_PROFILE: `${HOST_URL}${PATHS.PROFILE}`,
  BOOST_PROPERTY_DETAIL: (requirementId: string, propertyId: string) =>
    `${HOST_URL}${PATHS.BOOST_PROPERTY_DETAIL(requirementId, propertyId)}`,
  ASSOCIATION_AGENCIES: `${HOST_URL}${PATHS.ASSOCIATION_AGENCIES}`,
  ASSOCIATION_PROPERTIES: `${HOST_URL}${PATHS.ASSOCIATION_PROPERTIES}`,
  ASSOCIATION_BROKERS: `${HOST_URL}${PATHS.ASSOCIATION_BROKERS}`,
  ASSOCIATION_REPORTS: `${HOST_URL}${PATHS.ASSOCIATION_REPORTS}`,
  COMPA_LINK: 'https://compa.financial/',
  MONOPOLIO_ASESORES: 'https://monopolio.com.mx/asesores?utm_source=wiggot&utm_medium=wiggot&utm_campaign=wiggot',
  ACCOUNT_PROFILE: `${HOST_URL}${PATHS.ACCOUNT_PROFILE}`,
  ACCOUNT_AGENCY: `${HOST_URL}${PATHS.ACCOUNT_AGENCY}`,
  ACCOUNT_MEMBERS: `${HOST_URL}${PATHS.ACCOUNT_MEMBERS}`,
  PROPERTY_PERFORMANCE: `${HOST_URL}${PATHS.PROPERTY_PERFORMANCE}`,
  COMPA_LENDING: `${HOST_URL}${PATHS.COMPA_LENDING}`,
  SUSCRIPTION_EXPIRED: `${HOST_URL}${PATHS.SUSCRIPTION_EXPIRED}`,
  PUBLIC_PROPERTY: ({
    slug,
    propertyId,
    ref
  }: {
    slug: string
    propertyId: string
    ref?: string
  }) => `${HOST_URL}${PATHS.PUBLIC_PROPERTY({ slug, propertyId, ref })}`
}
